<template>
  <div class="office-details" v-loading="isLoading">
    <el-row :gutter="18">
      <el-col :md="24" class="mb-3">
        <el-card class="box-card" :body-style="{ padding: '20px 20px 2px 20px' }">
          <div slot="header" class="clearfix detail-header">
            <i class="fa fa-map-marker-alt"></i>Office
            <el-button type="primary" icon="fa fa-pencil-alt" class="mr-3" @click="editOffice"
              v-if="isAdmin">Edit</el-button>
          </div>
          <el-row :gutter="18" justify="start">
            <el-col :sm="12" :lg="6">
              <static-field label="Store Num." :value="office.storeNum" />
            </el-col>
            <el-col :sm="12" :lg="6">
              <static-field label="User Id" :value="office.userId" />
            </el-col>
            <el-col :sm="12" :lg="6">
              <static-field label="Address" :value="address" />
            </el-col>
            <el-col :sm="12" :lg="6">
              <static-field label="EFIN" :value="office.efin" />
            </el-col>
            <el-col :sm="12" :lg="6">
              <static-field label="IP" :value="office.ip" />
            </el-col>
            <el-col :sm="12" :lg="6">
              <static-field label="Phone" :value="office.phone" />
            </el-col>
            <el-col :sm="12" :lg="6">
              <static-field label="Brand" :value="prettyNameForBrand" />
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="18">
      <el-col :md="12" class="mb-3">
        <office-balance-card :typeId="EarlyBirdTransactionType" :officeId="office.id"></office-balance-card>
      </el-col>
      <el-col :md="12" class="mb-3">
        <office-balance-card :typeId="RAFTransactionType" :officeId="office.id"></office-balance-card>
      </el-col>
    </el-row>
    <el-row :gutter="18">
      <el-col :md="24" class="mb-3">
        <el-card>
          <transaction-grid :for-office-id="office.id" fixed-height v-if="office.id"></transaction-grid>
        </el-card>
      </el-col>
    </el-row>
    <el-dialog title="Edit Office" :visible.sync="editOfficeDialogVisible" :show-close="false"
      :close-on-click-modal="false" :close-on-press-escape="false" width="60%" v-if="isAdmin">
      <edit-office-dialog @close="editOfficeDialogVisible = false" :office="office"
        @officeUpdated="onOfficeUpdated"></edit-office-dialog>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import api from '@/api';
import Office from '@/model/Office';
import StaticField from '@/components/widgets/StaticField.vue';
import OfficeBalanceCard from '@/components/widgets/OfficeBalanceCard.vue';
import { TRANSACTION_TYPE } from '@/enum/TransactionType';
import EditOfficeDialog from '@/components/dialog-content/EditOffice.vue';
import TransactionGrid from '@/components/grid/TransactionGrid.vue';
import { BRAND_DESCRIPTION_MAP } from '@/enum/Brand';

export default {
  data() {
    return {
      isLoading: false,
      office: new Office(),
      editOfficeDialogVisible: false,
    };
  },
  watch: {
    '$route.params.officeId': {
      immediate: true,
      async handler(officeId) {
        try {
          this.isLoading = true;
          const response = await api.office.get(officeId);
          this.office = new Office(response.data);
        } catch (e) {
          this.$notify({
            type: 'error',
            title: 'Error',
            message: e.message || 'An error occurred while loading the office',
          });
        } finally {
          this.isLoading = false;
        }
      },
    },
  },
  methods: {
    editOffice() {
      this.editOfficeDialogVisible = true;
    },
    onOfficeUpdated(office) {
      this.office = new Office(office);
    },
  },
  computed: {
    ...mapGetters('User', ['isAdmin']),
    address() {
      if (this.office) {
        const address = this.office.address || '';
        const city = this.office.city || '';
        const state = this.office.state || '';
        const zip = this.office.zip || '';

        let addressString = '';
        if (address.length) {
          addressString += `${address}\n`;
        }
        if (city.length) {
          addressString += city + (state.length ? ', ' : '');
        }

        addressString += `${state} ${zip}`;
        return addressString;
      }
      return '';
    },
    prettyNameForBrand() {
      return BRAND_DESCRIPTION_MAP[this.office.brand];
    },
    RAFTransactionType() {
      return TRANSACTION_TYPE.RAF;
    },
    EarlyBirdTransactionType() {
      return TRANSACTION_TYPE.EARLY_BIRD;
    },
  },
  components: {
    StaticField,
    OfficeBalanceCard,
    EditOfficeDialog,
    TransactionGrid,
  },
};

</script>

<style lang="scss" scoped>
.detail-header {
  font-size: 18px;
  font-weight: bold;
  line-height: 24px;

  button {
    float: right;
    padding: 5px 5px;
  }
}
</style>
